// extracted by mini-css-extract-plugin
export var sbShowMain = "pagination-module--sb-show-main--HYPxK";
export var pagination = "pagination-module--pagination--3J-bq";
export var paginationInner = "pagination-module--paginationInner--2vY8n";
export var disabled = "pagination-module--disabled--1Ztaj";
export var current = "pagination-module--current--311xu";
export var next = "pagination-module--next--2VpcX";
export var prev = "pagination-module--prev--1MyPn";
export var dots = "pagination-module--dots--2NwWs";